<template>
    <div>
        <Header />
        <TitlePage />
            <div class="faq">
                <b-container fluid="md">
                    <div class="agents-invitation">
                        {{$t('agency.pageWillRedirect')}}
                    </div>
                </b-container>
            </div>
        <Footer/>
    </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

import Header from '@/components/ui/header';
import TitlePage from '@/components/ui/titlePage';
import Footer from '@/components/ui/footer';
export default {
    components:{
        Header,
        TitlePage,
        Footer
    },
    created(){
        console.log("this.$router",this.$router.history.current.query.invitation_code);
        if(this.$router.history.current.query.invitation_code){
            this.activeAgentsFromAgency();
        }
    },
    methods:{
        ...mapActions('AdminAgencyController',['ACTIVE_AGENTS_INVITATION']),
        activeAgentsFromAgency(){
            this.ACTIVE_AGENTS_INVITATION({invitationCode:this.$router.history.current.query.invitation_code}).then((data)=>{
                console.log("data",data);
                if(data.data.status!=500){
                    this.$bvToast.toast(this.$t('agency.invitationAccepted'), {
                        title: this.$t('agency.pageWillRedirect'),
                        variant: 'success',
                        solid: true,
                    });
                    this.$router.push('/');
                }else{
                    this.$bvToast.toast(this.$t('agency.createdError'), {
                        title:this.$t('agency.createdError'),
                        variant: 'danger',
                        solid: true,
                    });
                }
            }).catch((err)=>{
                console.log("err",err)
                this.$bvToast.toast(this.$t('agency.createdError'), {
                        title: this.$t('agency.createdError'),
                        variant: 'danger',
                        solid: true,
                    });
            })
        }
    }
    
}
</script>
<style lang="scss">
    @import 'agencyInvitation.scss';
</style>